var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLorryOutline = function SvgLorryOutline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_22789)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.33106 11.9971V3.99902C9.33106 3.64549 9.19062 3.30643 8.94063 3.05644C8.69064 2.80646 8.35159 2.66602 7.99805 2.66602H2.66602C2.31248 2.66602 1.97342 2.80646 1.72344 3.05644C1.47345 3.30643 1.33301 3.64549 1.33301 3.99902V11.3306C1.33301 11.5073 1.40323 11.6769 1.52822 11.8019C1.65322 11.9269 1.82274 11.9971 1.99951 11.9971H3.33252",
    stroke: "#2355FC",
    strokeWidth: 1.33301,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.99756 11.9971H5.99854",
    stroke: "#2355FC",
    strokeWidth: 1.33301,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.6636 11.9971H13.9966C14.1734 11.9971 14.3429 11.9269 14.4679 11.8019C14.5929 11.6769 14.6631 11.5073 14.6631 11.3306V8.89783C14.6628 8.74657 14.6111 8.59991 14.5165 8.48193L12.197 5.58264C12.1347 5.50458 12.0556 5.44153 11.9656 5.39815C11.8756 5.35477 11.777 5.33217 11.6771 5.33203H9.33105",
    stroke: "#2355FC",
    strokeWidth: 1.33301,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.3306 13.3301C12.0668 13.3301 12.6636 12.7333 12.6636 11.9971C12.6636 11.2609 12.0668 10.6641 11.3306 10.6641C10.5944 10.6641 9.99756 11.2609 9.99756 11.9971C9.99756 12.7333 10.5944 13.3301 11.3306 13.3301Z",
    stroke: "#2355FC",
    strokeWidth: 1.33301,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.66553 13.3301C5.40173 13.3301 5.99854 12.7333 5.99854 11.9971C5.99854 11.2609 5.40173 10.6641 4.66553 10.6641C3.92933 10.6641 3.33252 11.2609 3.33252 11.9971C3.33252 12.7333 3.92933 13.3301 4.66553 13.3301Z",
    stroke: "#2355FC",
    strokeWidth: 1.33301,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_22789"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15.9961,
    height: 15.9961,
    fill: "white"
  })))));
};
export default SvgLorryOutline;